import React from "react";
import { Modal, Button, Space, Typography } from "antd";

const { Text } = Typography;

interface ShortcutsModalProps {
  visible: boolean;
  onClose: () => void;
}

export const ShortcutsModal: React.FC<ShortcutsModalProps> = ({
  visible,
  onClose,
}) => {
  return (
    <Modal
      className="mobile-modal"
      title={<Space>⌨️ Keyboard Shortcuts</Space>}
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          Close
        </Button>,
      ]}
      width="100%"
    >
      <div style={{ fontSize: "14px" }}>
        <div style={{ marginBottom: "20px" }}>
          <Text strong style={{ fontSize: "16px", color: "#1890ff" }}>
            🗂️ Tab Navigation
          </Text>
          <div style={{ marginTop: "8px", marginLeft: "16px" }}>
            <div>
              <kbd>1</kbd> • 🚧 Not in Storage
            </div>
            <div>
              <kbd>2</kbd> • 🏪 In Storage
            </div>
          </div>
        </div>

        <div style={{ marginBottom: "20px" }}>
          <Text strong style={{ fontSize: "16px", color: "#52c41a" }}>
            ⚡ Quick Actions
          </Text>
          <div style={{ marginTop: "8px", marginLeft: "16px" }}>
            <div>
              <kbd>S</kbd> • Toggle Zebra Scanner Mode
            </div>
            <div>
              <kbd>F</kbd> • Focus Search Bar
            </div>
            <div>
              <kbd>E</kbd> • Expand/Collapse All Bookings
            </div>
            <div>
              <kbd>R</kbd> • Reset Container
            </div>
            <div>
              <kbd>Ctrl+R</kbd> / <kbd>⌘+R</kbd> • Refresh Data
            </div>
            <div>
              <kbd>Ctrl+?</kbd> / <kbd>⌘+?</kbd> • Show This Help
            </div>
          </div>
        </div>

        <div style={{ marginBottom: "20px" }}>
          <Text strong style={{ fontSize: "16px", color: "#faad14" }}>
            📝 Form Navigation
          </Text>
          <div style={{ marginTop: "8px", marginLeft: "16px" }}>
            <div>
              <kbd>Enter</kbd> • Move to Next Field
            </div>
            <div>
              <kbd>Enter</kbd> on Carton Input • Set to Estimated
            </div>
            <div>
              <kbd>Ctrl+Enter</kbd> in Text Areas • Save Form
            </div>
            <div>
              <kbd>Tab</kbd> / <kbd>Shift+Tab</kbd> • Navigate Fields
            </div>
          </div>
        </div>

        <div style={{ marginBottom: "20px" }}>
          <Text strong style={{ fontSize: "16px", color: "#722ed1" }}>
            📱 Zebra Scanner
          </Text>
          <div style={{ marginTop: "8px", marginLeft: "16px" }}>
            <div>📷 • Scan EAN Codes with Zebra mobile device</div>
            <div>
              ➕ • Auto-increment carton count by +1 (when Zebra Scanner Mode is
              ON)
            </div>
            <div>
              🔍 • Search bar typing only highlights products (no increment)
            </div>
            <div>⏰ • 50ms timeout optimized for Zebra scanners</div>
          </div>
        </div>

        <div
          style={{
            backgroundColor: "#f6ffed",
            border: "1px solid #b7eb8f",
            borderRadius: "6px",
            padding: "12px",
            marginTop: "16px",
          }}
        >
          <Text strong style={{ color: "#389e0d" }}>
            💡 Pro Tips
          </Text>
          <div style={{ marginTop: "8px", fontSize: "13px", color: "#389e0d" }}>
            • Use number keys (1-2) to quickly switch between storage status
            tabs
            <br />
            • Enable Zebra Scanner Mode (S) for hands-free carton counting
            <br />
            • Enter key on carton inputs acts like "All" button
            <br />
            • Ctrl+Enter saves forms without using mouse
            <br />• Use virtual palletizing for goods staying per carton
          </div>
        </div>
      </div>
    </Modal>
  );
};
